import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Grid } from '@material-ui/core';
import axios from 'axios';
import { Formik, Field, Form } from 'formik';
import * as Yup from "yup";
import { FormikTextField } from '../shared/Formik/FormikTextField';
import { FormikAutoCompleteField } from '../shared/Formik/FormikAutoCompleteField';
import { HeaderContainer, HeaderWrapper } from '../CampaignDetails/CampaignDetails.styles';
import { StyledInformationName, CharactersInfo } from '../CampaignEdit/CampaignEdit.styles';
import { MarginWrapper } from '../Dashboard/Dashboard.styles';
import { useAuth } from '../context/auth';
import { StyledButton } from './Support.styles';
import {
    SubjectType,
    CampaignApiResponse,
    CampaignType 
} from './Support.interface';

const validationSchema = Yup.object().shape({
    subject: Yup.object().required('Subject is required'),
    campaign: Yup.object(),
    description: Yup.string().required("Description is required").max(450, 'Description can have maximum 450 characters'),
  });

export function Support() {
    const { authToken, user } = useAuth();
    const history = useHistory();
    const [subjectsList, setSubjectsList] = useState<SubjectType>();
    const [campaignsList, setCampaignsList] = useState<CampaignType>();
    useEffect(() => {
        window.scrollTo(0, 0);
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/support/questions/subjects/`, {headers: { DTOKEN: `${authToken}`}}).then(res => {
            setSubjectsList(res.data)
        })
        axios.get(`${process.env.REACT_APP_BASE_URL}/api/support/questions/campaign-titles`, {headers: { DTOKEN: `${authToken}`}}).then(res => {
            const results = res.data.map((campaign: CampaignApiResponse) => {
                return {
                    id: campaign.id,
                    name: campaign.title
                }
            });
            setCampaignsList(results);
        })
    }, [])   
    return (
        <>
            <MarginWrapper verified={user ? user.verifiedAccount : false}>
                <HeaderWrapper>
                    <HeaderContainer>
                        <h1>Support</h1>
                    </HeaderContainer>
                </HeaderWrapper>
            </MarginWrapper>
            <Container>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <h1>
                            Questions or issues with your campaign?<br/>
                            Contact us!
                        </h1>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Formik
                            initialValues={{
                                user: "",
                                subject: {id: "", name: ""},
                                campaign: {id: "", name: ""},
                                description: ""
                            }}
                            onSubmit={(values) => {
                                const data = {
                                    user: authToken,
                                    subject: values.subject.id,
                                    campaign: values.campaign.id,
                                    description: values.description
                                }
                                axios.post(`${process.env.REACT_APP_BASE_URL}/api/support/questions/`, data, {headers: { DTOKEN: `${authToken}`}}).then(() => {
                                    history.push(`${process.env.REACT_APP_INTERNAL_URL}support/success`);
                                })
                            }}
                            validationSchema={validationSchema}
                        >
                            <Form>
                                {subjectsList && campaignsList &&
                                    <>
                                        <StyledInformationName>Subject</StyledInformationName>
                                        <Field
                                            name='subject'
                                            fullWidth
                                            variant='outlined'
                                            options={subjectsList}
                                            component={FormikAutoCompleteField}
                                        />
                                        <StyledInformationName>Campaign Title (optional)</StyledInformationName>
                                        <Field
                                            name='campaign'
                                            fullWidth
                                            variant='outlined'
                                            options={campaignsList}
                                            component={FormikAutoCompleteField}
                                        />
                                    </>
                                }
                                <StyledInformationName>Description</StyledInformationName>
                                <Field 
                                    name="description"
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={7}
                                    component={FormikTextField}
                                    placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla accumsan lorem enim, in luctus erat laoreet vehicula."
                                />
                                <CharactersInfo>Maximum of 450 characters</CharactersInfo>
                                <StyledButton type='submit'>Submit</StyledButton>
                            </Form>
                        </Formik>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}
